import { ComponentProps, CSSProperties, ReactNode } from 'react';
import styles from './head.module.css';

interface Props extends ComponentProps<'div'> {
  children: ReactNode;
  style?: CSSProperties;
}

export const Head = ({ children, style, ...props }: Props) => {
  return (
    <div
      className={`${styles.header} ${props.className}`}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
};
